import { render, staticRenderFns } from "./ItemRelay.vue?vue&type=template&id=12b6cca7&scoped=true&"
import script from "./ItemRelay.vue?vue&type=script&lang=js&"
export * from "./ItemRelay.vue?vue&type=script&lang=js&"
import style0 from "./ItemRelay.vue?vue&type=style&index=0&id=12b6cca7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b6cca7",
  null
  
)

export default component.exports